import ApiClient from "@common/api/ApiClient";

class Session extends ApiClient {
  constructor() {
    super("Session");
  }

  Sessions = async (installationId, periodId, pageNumber = 1) => {
    return await this.get(
      `Sessions2/${installationId},${periodId},${pageNumber}`,
    );
  };

  SessionsCompliance = async (installationId, periodId, pageNumber = 1) => {
    return await this.get(
      `compliance/sessions/${installationId},${periodId},${pageNumber}`,
    );
  };

  AlertSessions = async (
    periodId = 0,
    pageNumber = 1,
    includeNonAlerts = true,
  ) => {
    return await this.get(
      `compliance/alert/sessions/${periodId},${pageNumber},${includeNonAlerts}`,
    );
  };

  Positions = async (online, offline, nonOp) => {
    return await this.get(`Positions/${online},${offline},${nonOp}`);
  };

  CompliancePositions = async (online, offline, nonOp, siteId) => {
    return await this.get(
      `Compliance/Positions/${online},${offline},${nonOp},${siteId}`,
    );
  };

  Session = async (sessionId) => {
    return await this.get(`Session/${sessionId}`);
  };

  SessionByGuid = async (sessionGuid) => {
    return await this.get(`Session/byGuid/${sessionGuid}`);
  };

  LiveFloorView = async (installationId, periodId, pageNumber = 1) => {
    return await this.get(
      `Sessions/LFV/${installationId},${periodId},${pageNumber}`,
    );
  };
}

const client = new Session();

export default client;
